import React, { FC, useCallback } from 'react';
import { Modal, Text } from '@wix/design-system';
import { useScreenWidth } from '../../hooks/useScreenWidth';
import { useUouLanguage } from '../../hooks/useUouLanguage';
import { ConnectCalendarModalContent, ConnectCalendarModalContentProps } from './components';
import { ConnectCalendarModalDesktopLayout, ConnectCalendarModalMobileLayout } from './layouts';
import { ConnectCalendarModalLayoutProps } from './types';

interface ConnectCalendarModalProps extends ConnectCalendarModalContentProps {
  isOpen: boolean;
  onClose: () => void;
  assistantName: string;
}

export const ConnectCalendarModal: FC<ConnectCalendarModalProps> = ({ isOpen, onClose, onAuthSuccess, onAuthFailure, assistantName }) => {
  const { isMobile } = useScreenWidth();
  const language = useUouLanguage();

  const onAuthSuccessHandler = useCallback(() => {
    onAuthSuccess && onAuthSuccess();
    onClose();
  }, [onClose, onAuthSuccess]);

  const onAuthFailureHandler = useCallback(() => {
    onAuthFailure && onAuthFailure();
    onClose();
  }, [onClose, onAuthFailure]);

  const layoutProps: ConnectCalendarModalLayoutProps = {
    title: language.ASA_STANDALONE_CONNECT_CALENDAR_MODAL_TITLE(),
    subtitle: language.ASA_STANDALONE_CONNECT_CALENDAR_MODAL_SUBTITLE(assistantName),
    onCloseButtonClick: onClose,
    footnote: (
      <Text size="tiny" weight="thin">
        {language.ASA_STANDALONE_CONNECT_CALENDAR_MODAL_FOOTNOTE()}
      </Text>
    ),
    content: <ConnectCalendarModalContent onAuthSuccess={onAuthSuccessHandler} onAuthFailure={onAuthFailureHandler} />,
  };

  return (
    <Modal isOpen={isOpen} screen={isMobile ? 'mobile' : 'desktop'}>
      {isMobile ? <ConnectCalendarModalMobileLayout {...layoutProps} /> : <ConnectCalendarModalDesktopLayout {...layoutProps} />}
    </Modal>
  );
};
